import _ from 'lodash';

export default function (instance) {
  instance.sync_link_create = function (link) {
    if (instance.isTaskExists(link.source)) {
      const sourceTask = instance.getTask(link.source);

      sourceTask.$source = sourceTask.$source || [];

      if (sourceTask.$source.indexOf(link.id) === -1) {
        sourceTask.$source.push(link.id);
      }
    }

    if (instance.isTaskExists(link.target)) {
      const targetTask = instance.getTask(link.target);

      targetTask.$target = targetTask.$target || [];

      if (targetTask.$target.indexOf(link.id) === -1) {
        targetTask.$target.push(link.id);
      }
    }
  };

  instance.sync_link_delete = function (link) {
    if (instance.isTaskExists(link.source)) {
      const sourceTask = instance.getTask(link.source);

      _.remove(sourceTask.$source, linkId => +linkId === +link.id);

      instance.refreshTask(link.source);
    }

    if (instance.isTaskExists(link.target)) {
      const targetTask = instance.getTask(link.target);

      _.remove(targetTask.$target, linkId => +linkId === +link.id);

      instance.refreshTask(link.target);
    }
  };
}
